import toastService from '@/services/toast';

export default {
  install(app) {
    // console.log('Registering $toast plugin');
    app.config.globalProperties.$toast = toastService;
  },
};